import Vue from 'vue';
import Router from 'vue-router';
import { storage } from 'BASE/common/util/util.storage';

const CenterLeftMenu = () => import('TS/views/CenterLeftMenu.vue');
const Login = () => import('TS/views/Login/Login.vue');
const ChatAnonymity = () => import('TS/views/ChatAnonymity/ChatAnonymity.vue');
const Timeout = () => import('TS/views/ErrorHandle/Timeout.vue');
const Offline = () => import('TS/views/ErrorHandle/Offline.vue');
const Home = () => import('TS/views/Home/Home.vue');
const ErrorMsg = () => import('TS/views/ErrorHandle/ErrorMsg.vue');
const IPRestricted = () => import('TS/views/ErrorHandle/IPRestricted.vue');
const LinkFailure = () => import('TS/views/Register/Register.LinkFailure.vue');
const Bet = () => import('TS/views/Bet/Bet.vue');

const AccountInfo = () => import('TS/views/AccountCenter/AccountInfo.vue');
const AwardDetail = () => import('TS/views/AwardDetail/AwardDetail.vue');
const MyDailyPay = () => import('TS/views/DailyPay/MyDailyPay.vue');
const AccountSecurity = () => import('TS/views/AccountCenter/AccountSecurity.vue');
const LoginRecord = () => import('TS/views/LoginRecord/LoginRecord.vue');
const DepositRequestCreate = () => import('TS/views/DepositRequest/Create.vue');
const DepositQrcode = () => import('TS/views/DepositRequest/DepositQrcode.vue');
const DepositPayInfo = () => import('TS/views/DepositRequest/PayInfo.vue');
const DownloadHuangingupApplication = () => import('TS/views/Download/HangingUpApplication.vue');
const AndroidDownload = () => import('TS/views/Download/AndroidDownload.vue');
const iosDownload = () => import('TS/views/Download/iosDownload.vue');
const CreatePlayer = () => import('TS/views/Player/Player.Create.vue');
const Player = () => import('TS/views/Player/Player.vue');
const TradeAgreement = () => import('TS/views/Login/TradeAgreement.vue');
const HelperCenter = () => import('TS/views/Home/HelperCenter.vue')
const WithdrawRequest = () => import('TS/views/WithdrawRequest/WithdrawRequest.vue');
const RegisterLink = () => import('TS/views/RegisterLink/RegisterLink.vue');
const WeChatRegisterLink = () => import('TS/views/RegisterLink/RegisterLink.WeChat.vue');
const BankCard = () => import('TS/views/BankCard/BankCard.vue')
const CreateBankCard = () => import('TS/views/BankCard/BankCard.Create.vue');
const CreateAliPay = () => import('TS/views/BankCard/AliPay.Create.vue');
const CreateWeChat = () => import('TS/views/BankCard/WeChat.Create.vue');
const CreateENCY = () => import('TS/views/BankCard/ENCY.Create.vue');
const Register = () => import('TS/views/Register/Register.vue');
const WeChatRegister = () => import('BASE/components/register/register.wechat.component.js');
const DepositAndWithdrawRecord = () => import('TS/views/DepositAndWithdrawRecord/DepositAndWithdrawRecord.vue');
const ExternalGameTransRecord = () => import('TS/views/ExternalGameTransRecord/ExternalGameTransRecord.vue');
const ExternalGameSubItem = () => import('TS/views/ExternalGame/ExternalGameSubItem.vue');
const TrendChartStatistics = () => import('TS/views/TrendChart/Statistics.vue');
const TrendChartOverview = () => import('TS/views/TrendChart/Overview.vue');
const TransferPointRecord = () => import('TS/views/TransferPointRecord/TransferPointRecord.vue');
const Transfer = () => import('TS/views/TransferPoint/Transfer.vue');
const UserStatisticsReport = () => import('TS/views/UserStatisticsReport/UserStatisticsReport.vue');
const BetRecord = () => import('TS/views/BetRecord/BetRecord.Main.vue');
const DividendRecord = () => import('TS/views/DividendRecord/DividendRecord.vue');
const ProfitReport = () => import('TS/views/ProfitReport/ProfitReport.Main.vue');
const ScheduleRecord = () => import('TS/views/ScheduleRecord/ScheduleRecord.Main.vue');
const CashFlowRecord = () => import('TS/views/CashFlowRecord/CashFlowRecord.Main.vue');
const LotteryGameStatistics = () => import('TS/views/LotteryGameStatistics/LotteryGameStatistics.Main.vue');
const DrawHistory = () => import('TS/views/DrawHistory/DrawHistory.vue');
const CreateUSDTAddress = () => import('TS/views/USDTAddress/USDTAddress.Create.vue');
const LegendDownload = () => import('TS/views/Download/LegendDownload.vue');
const LoginDownload = () => import('TS/views/Download/LoginDownload.vue');
const ElectronicPurseManualCreate = () => import('TS/views/ElectronicPurse/ElectronicPurse.create.manual.vue');
const ElectronicPurseQRCodeCreate = () => import('TS/views/ElectronicPurse/ElectronicPurse.create.qrcode.vue');
const Activity = () => import('TS/views/Activity/Activity.vue');

Vue.use(Router);

Router.prototype.refreshTo = function (path) {
    window.location.href = path;
};

const router = new Router({
    mode: 'history',
    linkActiveClass: 'active',
    routes: [
        { path: '/Login', name: 'Login', component: Login, meta: { ignoreAuth: true } },
        { path: '/TradeAgreement', component: TradeAgreement, meta: { ignoreAuth: true } },
        { path: '/ChatAnonymity', name: 'ChatAnonymity', component: ChatAnonymity, meta: { ignoreAuth: true } },
        { path: '/Timeout', component: Timeout, meta: { ignoreAuth: true } },
        { path: '/Offline', component: Offline, meta: { ignoreAuth: true } },
        { path: '/LinkFailure', component: LinkFailure, meta: { ignoreAuth: true } },
        { path: '/ErrorMsg', name: 'ErrorMsg', component: ErrorMsg, meta: { ignoreAuth: true } },
        { path: '/IPRestricted', name: 'IPRestricted', component: IPRestricted, meta: { ignoreAuth: true } },
        { path: '/DepositPayInfo/:SerialNumber', name: 'DepositPayInfo', component: DepositPayInfo, meta: { ignoreAuth: true } },
        { path: '/Register/:code', name: 'Register', component: Register, meta: { ignoreAuth: true } },
        { path: '/WeChatRegister/:code', name: 'WeChatRegister', component: WeChatRegister, meta: { ignoreAuth: true } },
        //以上是忽略驗證是否有登入，需登入後才顯得ignoreAuth請不要設置

        { path: '/', name: 'Home', component: Home},
        { path: '/Bet/:id', name: 'Bet', component: Bet },
        { path: '/DepositQrcode', name: 'DepositQrcode', component: DepositQrcode },
        { path: '/HangingUpApplication', component: DownloadHuangingupApplication },
        { path: '/AndroidAppDownload', component: AndroidDownload },
        { path: '/iosAppDownload', component: iosDownload },
        { path: '/HelperCenter', component: HelperCenter },
        { path: '/ExternalGameSubItem/:gameType', component: ExternalGameSubItem },
        { path: '/LegendDownload', component: LegendDownload },
        { path: '/LoginDownload', component: LoginDownload },
        { path: '/Activity', name: 'Activity', component: Activity },
        {
            path: '/Center', component: CenterLeftMenu,
            children: [
                { path: 'AccountInfo', component: AccountInfo },
                { path: 'AwardDetail', component: AwardDetail },
                { path: 'MyDailyPay', component: MyDailyPay },
                { path: 'BankCard', name: 'BankCard', component: BankCard },
                { path: 'CreateBankCard', name: 'CreateBankCard', component: CreateBankCard },
                { path: '/CreateAliPay/:CurrentBankType', name: 'CreateAliPay', component: CreateAliPay, props: true },
                { path: '/CreateWeChat/:CurrentBankType', name: 'CreateWeChat', component: CreateWeChat, props: true },
                { path: '/CreateECNY/:CurrentBankType', name: 'CreateENCY', component: CreateENCY, props: true },
                { path: 'AccountSecurity', component: AccountSecurity },
                { path: 'LoginRecord', component: LoginRecord },
                { path: 'DepositCreate', component: DepositRequestCreate },
                { path: 'CreatePlayer', component: CreatePlayer, meta: { isAgentAllow: true } },
                { path: 'Player', component: Player, meta: { isAgentAllow: true } },
                { path: 'WithdrawRequest', component: WithdrawRequest },   
                { path: 'RegisterLink', component: RegisterLink, meta: { isAgentAllow: true } },
                { path: 'WeChatRegisterLink', component: WeChatRegisterLink, meta: { isAgentAllow: true } },
                { path: 'ExternalGameTransRecord', component: ExternalGameTransRecord },
                { path: 'DepositAndWithdrawRecord', component: DepositAndWithdrawRecord },
                { path: 'TrendChartStatistics', component: TrendChartStatistics, meta: { isAgentAllow: true } },
                { path: 'TrendChartOverview', component: TrendChartOverview, meta: { isAgentAllow: true } },
                { path: 'TransferPointRecord', component: TransferPointRecord },
                { path: 'UserStatisticsReport', component: UserStatisticsReport, meta: { isAgentAllow: true } },
                { path: 'Transfer', name:'Transfer', component: Transfer },
                { path: 'BetRecord',name:'BetRecord', component: BetRecord},
                { path: 'DividendRecord',name:'DividendRecord', component: DividendRecord},
                { path: 'ProfitReport', component: ProfitReport },
                { path: 'ScheduleRecord', component: ScheduleRecord },
                { path: 'CashFlowRecord', component: CashFlowRecord },
                { path: 'LotteryGameStatistics', component: LotteryGameStatistics },
                { path: 'CreateUSDTAddress/:currencyType', name: 'CreateUSDTAddress', component: CreateUSDTAddress },
                { path: 'CreateElectronicPurseManual', name: 'ElectronicPurseManualCreate', component: ElectronicPurseManualCreate, props: true },
                { path: 'CreateElectronicPurseQRCode', name: 'ElectronicPurseQRCodeCreate', component: ElectronicPurseQRCodeCreate, props: true },
            ]
        },
        { path: '/DrawHistory/:id',name:'DrawHistory', component: DrawHistory },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.name == "Login") {
        //透過window.location.href跳回Login遇載app.vue時會是之前的權限需將token先砍掉
        storage.local.remove(storage.keys.ACCESS_TOKEN);
    }

    if (to.matched.some(record => record.meta.ignoreAuth)) {
        next();
    } else {
        let isAgent = storage.local.get(storage.keys.ISAGENT);
        if (to.matched.some(record => record.meta.isAgentAllow) && !isAgent) {
            //若登入帳號不是Agent，則回到首頁
            next('/');
        }
        if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
            next();
        }
        else if (to.name === "Home" && from.fullPath === to.fullPath) {
            //如平台沒有未登入首頁時須設定該部分，當玩家直接透過網址做網頁跳轉時如沒token需直接跳到登入
            router.refreshTo('/speedtest');
        }
        else {
            next('/Timeout');   // 認證已過期
        }
    }
});

export default router;